export function getResourceWarningTexts(resourceWarnings, t) {
  const warningFields = ['license', 'location', 'specialty', 'financier', 'identification', 'dob', 'gender'];
  
  return warningFields
    .filter(field => resourceWarnings?.[field])
    .map(field => t(field, { context: 'resources' }));
}